import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useWorkspace } from '@mssgme/hooks';
import { SidebarHeader, LinkButton, ScrollableBox, NavBackButton, Toggleable, Feature } from '@mssgme/ui';

import { PageLayout } from '../../../UI';

import styles from './PageLinks.scss';

export default function PageLinks() {
    const { t } = useTranslation('cards');
    const {
        card: { links },
    } = useWorkspace();

    const leftButton = <NavBackButton to="/p/edit" />;

    return (
        <PageLayout>
            <SidebarHeader heading={t('pageLinks.links')} leftButton={leftButton} />
            <ScrollableBox>
                <Feature rule="links:?">
                    {links.length === 0 && <p className={styles.noLinksMessage}>{t('pageLinks.description')}</p>}
                    {links.length > 0 && (
                        <div className={styles.linksContainer}>
                            {links.map((link) => (
                                <div key={link._id} className={styles.link}>
                                    <span className={styles.title}>{link.title}</span>
                                    <Toggleable
                                        className={styles.value}
                                        tag={Link}
                                        to={`/p/edit/links/${link._id}`}
                                        enabled={link.enabled}
                                    >
                                        {link.url}
                                    </Toggleable>
                                </div>
                            ))}
                        </div>
                    )}
                    <LinkButton to="/p/edit/links/new" className={styles.fullWidth}>
                        {t('pageLinks.add_link')}
                    </LinkButton>
                </Feature>
            </ScrollableBox>
        </PageLayout>
    );
}
